<template>
    <div class="w-full flex flex-col items-start justify-start space-y-1 border-b border-gray-300 pb-2">
        <div class="flex-col">
            <div class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">Full Name:</div>
            <input type="text" placeholder="Prefix" required class="p-1 border h-full w-full inline rounded-t" v-model="contactData.prefix">
            <input type="text" placeholder="First" required class="p-1 border h-full w-full inline" v-model="contactData.first_name">
            <input type="text" placeholder="Preferred" required class="p-1 border h-full w-full inline" v-model="contactData.preferred_name">
            <input type="text" placeholder="Middle" required class="p-1 border h-full w-full inline" v-model="contactData.middle_name">
            <input type="text" placeholder="Last" required class="p-1 border h-full w-full inline" v-model="contactData.last_name">
            <input type="text" placeholder="Suffix" required class="p-1 border h-full w-full inline rounded-b" v-model="contactData.suffix">
        </div>
        <div class="flex-col">
            <div class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">Business Info:</div>
            <input type="text" placeholder="Title" required class="p-1 border h-full w-full inline rounded-t" v-model="clientRelationshipData.title">
            <input type="text" placeholder="Business Email" required class="p-1 border h-full w-full inline" v-model="clientRelationshipData.email_address">
            <input type="text" placeholder="Business Phone" maxlength="50" required class="p-1 border h-full w-full inline" v-model="clientRelationshipData.phone_number">
            <select name="timeZone" v-model="clientRelationshipData.time_zone" class="p-1 border h-full w-full rounded" placeholder="Time Zone" id="">
                <option :value="null">--Time Zone--</option>
                <option value="UTC-09:00 (AKT) - Most of the state of Alaska">UTC-09:00 (AKT) - Most of the state of Alaska</option>
                <option value="UTC-08:00 (PT) - Pacific Time zone">UTC-08:00 (PT) - Pacific Time zone</option>
                <option value="UTC-07:00 (MT) - Mountain Time zone">UTC-07:00 (MT) - Mountain Time zone</option>
                <option value="UTC-06:00 (CT) - Central Time zone">UTC-06:00 (CT) - Central Time zone</option>
                <option value="UTC-05:00 (ET) - Eastern Time zone">UTC-05:00 (ET) - Eastern Time zone</option>                   
            </select>
            <textarea class="p-1 border h-full w-full rounded-b" placeholder='Notes' v-model="clientRelationshipData.contact_notes"></textarea>
        </div>
        <div class="flex-col w-full">
            <div class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">Personal Info:</div>
            <input type="text" placeholder="Personal Email" class="p-1 border h-full w-full rounded-t" v-model="contactData.personal_email">
            <input type="text" placeholder="Personal Phone" maxlength="50" class="p-1 border h-full w-full" v-model="contactData.personal_phone">
            <input type="text" placeholder="LinkedIn Profile" class="p-1 border h-full w-full rounded-b" v-model="contactData.linkedin_profile">
            <!-- <textarea class="p-1 border h-full w-full rounded-b" placeholder="Personal Notes" v-model="contactData.personal_notes"></textarea> -->
        </div>
        <div class="flex-col w-full">
            <div class="whitespace-nowrap tracking-wide font-semibold pr-1 text-gray-800">Is Primary Contact:</div>
            <select name="isPrimaryContact" v-model="clientRelationshipData.is_primary_contact" class="p-1 border h-full w-full rounded" id="">
                <option :value="true">True</option>
                <option :value="false" selected>False</option>
            </select>
        </div>
        <div class="flex flex-row space-x-1 pt-1 justify-end w-full">
            <base-button-affirmative @click="addContact">Save</base-button-affirmative>
            <base-button-negative @click="closeForm">Cancel</base-button-negative>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import { createContactAndClientRelationship } from '@/services/Contact';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';

    const store = useStore()

    const props = defineProps(['client'])

    const $toast = useToast()

    const emit = defineEmits(['refetch-clients', 'close-form'])

    const contactData = ref({
        first_name: null,
        last_name: null,
        personal_phone: null,
        personal_email: null,
        linkedin_profile: null,
        personal_notes: null,
        preferred_name: null,
    })

    const clientRelationshipData = ref({
        email_address: null,
        contact_notes: null,
        title: null,
        phone_number: null,
        time_zone: null,
        is_primary_contact: false,
        status: "active",
        client_id: props.client.id
    })

    function closeForm(){
        emit('close-form')
    }

    async function addContact(){
        const token = store.state.auth.token
        let errorMessage = "Error, missing "
        if(!contactData.value.first_name || !contactData.value.last_name){
            if(!contactData.value.action_name){
                errorMessage += "first name "
            }
            if(!contactData.value.last_name){
                errorMessage += "last name "
            }
            alert(errorMessage)
            return
        }
        const data = {
            "contact": contactData.value,
            "client_relationship": clientRelationshipData.value
        }
        console.log('form data', data)
        const response = await createContactAndClientRelationship(data, token)
        console.log('response', response)
        if (response.status == 200){
            $toast.open(
                {
                    message: `Contact created for ${props.client.client_name}`,
                    type: 'success',
                    duration: 20000
                }
            )
            emit('refetch-clients')
            emit('close-form')
        } else {
            $toast.open(
                {
                    message: `${response.response.data.detail}`,
                    type: 'error',
                    duration: 20000
                }
            )
        }

    }


</script>